export const rolesdef = {
    superAdmin: 'SUPADMIN',
    tenantAdmin: 'TENADMIN',
    admin: 'ADMIN',
    userW: 'USERL1',
    userR:'USERL2',
    master: 'MASTER',
    cuserW: 'CHILDUSER1',
    cuserR: 'CHILDUSER2',
    enduser: 'ENDUSER',
    oemuser: 'OEMUSER',
    posowner: 'POSOWNER'
}
